export class QueryParams {

  phrase: string = '';

  page: string | number;

  pageSize: string | number;

  searchInText: boolean;

  url: string = '';

  filters: string = '';

  sort: string = '';

  constructor(attr:{phrase?: string, page?: string | number, pageSize?: string | number, searchInText?: boolean, url?: string, filters?: string, sort?: string}) {
    this.phrase = attr.phrase;
    this.page = attr.page;
    this.pageSize = attr.pageSize;
    this.searchInText = attr.searchInText;
    this.url = attr.url;
    this.filters = attr.filters;
    this.sort = attr.sort;
  }
}
